import sessionDB from "../../utils/sessionDB";

export function getEmployeeName(employee) {
  return [employee?.firstName, employee?.middleName, employee?.lastName]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" ") || String(employee?.fullName || employee?.employeeName || "").trim();
}

export function getEmployeeTitleSuffix(employeeId, employeeName) {
  const id = String(employeeId ?? "").trim();
  const identity = sessionDB.getSession()?.onboardingEmployeeIdentity;
  const name = String(employeeName ?? (String(identity?.empId ?? "") === id ? identity?.name : "") ?? "").trim();
  return id && name ? " (" + id + " - " + name + ")" : "";
}
